import { IQueue } from "@/Settings/types/QueueMapping/QueueMapping";

const DEFAULT_QUEUE_NAME = "New Queue";
const OTHER_EMPLOYEES_POSITION = "Other Employees";

const MAX_OVERFLOW_QUEUE = 4;
const EMPTY_NAME = "";
const QUEUE_EMPTY_VALUE: IQueue = {
	_id: "",
	locationId: "",
	name: DEFAULT_QUEUE_NAME,
	usersByPosition: [],
	overflowQueues: [],
};

export { DEFAULT_QUEUE_NAME, OTHER_EMPLOYEES_POSITION, QUEUE_EMPTY_VALUE, EMPTY_NAME, MAX_OVERFLOW_QUEUE };
